import dayjs from 'dayjs';
import * as Yup from 'yup';
import { ZIPCODE_ERROR_VALIDATION_MSG, ZIPCODE_REGEX } from '../constants/address';

const app_co = process.env.REACT_APP_COMPANY;

export const Step1Schema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  tos_flag: Yup.boolean().isTrue('You must accept the terms of service').required('Required'),
  ...(app_co === 'frost' && {
    hipaa_npp_flag: Yup.boolean().isTrue('You must accept the HIPAA Notice of Privacy Practices').required('Required'),
  }),
});

export const Step2Schema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('Required')
    .matches(/^\S+$/, 'Phone number must not contain spaces')
    .test('no-hyphens', 'Phone number must not contain hyphens', (value) => !value || !value.includes('-')),
  birthdate: Yup.date()
    .nullable()
    .required('Birth date is required')
    .max(dayjs().subtract(18, 'years'), 'You must be at least 18 years old'),
  gender: Yup.string().required('Required'),
  ...(app_co === 'rh' && {
    address_1: Yup.string().required('Required'),
    address_2: Yup.string(),
    city: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    zipcode: Yup.string().required('Required'),
    occupation: Yup.string().required('Required'),
  }),
});

export const Step3Schema = Yup.object().shape({
  confirmationCode: Yup.string().required('Required'),
});

export const loginSchema = Yup.object().shape({
  email: Yup.string().required('Email is required'),
  otp: Yup.string(),
});

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
});

export const resetPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  code: Yup.string().required('Verification code is required'),
  newPassword: Yup.string()
    .min(8, 'New password must be at least 8 characters')
    .matches(/[A-Z]/, 'New password must have upper case letters')
    .matches(/\d/, 'New password must have numbers')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'New password must have special characters')
    .required('Required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm password is required'),
});

export const userProfileEditorValidationSchema = Yup.object({
  name: Yup.string().required('First name is required'),
  family_name: Yup.string().required('Last name is required'),
  gender: Yup.string().required('Gender is required'),
  birthdate: Yup.date()
    .nullable()
    .required('Date of Birth is required')
    .max(dayjs().subtract(18, 'years'), 'You must be at least 18 years old')
    .test('isValid', 'Invalid date format', (value) => !value || dayjs(value).isValid()),
  'custom:address_1': Yup.string().required('Address Line 1 is required'),
  'custom:city': Yup.string().required('City is required'),
  'custom:state': Yup.string().required('State is required'),
  'custom:zipcode': Yup.string().matches(ZIPCODE_REGEX, ZIPCODE_ERROR_VALIDATION_MSG).required('Required'),
  phone_number: Yup.string().required('Phone number is required'),
});
